import { GoogleAnalyticsEventsService } from './../../../services/google-analytics-events.service';
import { Component, OnChanges, Input, Output, EventEmitter, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

import { DownloadService } from '../../../services/download.service';
import { DataService } from 'src/app/services/data.service';
import {environment} from "../../../../environments/environment";

declare var window: any;
@Component({
  selector: 'app-results-grid',
  templateUrl: './results-grid.component.html',
  styleUrls: ['./results-grid.component.scss']
})
export class ResultsGridComponent implements OnChanges {

  @Input('domain') domain: string;
  @Input('options') options: any;
  @Input('columns') columns: any;
  @Input('details') details: any;
  @Input('crosstab') crosstab: any[];
  @Input('parties') parties: any;
  @Input('download') download: any;
  searchResults: any;
  @Input('searchResults') set setSearchResults(searchResults: any){
    this.searchResults = searchResults;
    this.stickyHeader();
  }
  @Input('sortMap') sortMap: any[];
  @Input('expandAll') expandAll: boolean;
  @Input() pageName: string;
  @Input() error: string;
  @Input() loading: boolean;
  @ViewChild('resulstGrid') resulstGrid: ElementRef;

  @Output() columnClick: EventEmitter<any>;
  @Output() toggleAll: EventEmitter<any>;
  @Output() loadingState: EventEmitter<boolean>;

  downloadError = false;
  downloading = false;

  constructor(
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsEventsService,
    private downloadService: DownloadService,
    private dataService: DataService) {
    this.columnClick = new EventEmitter();
    this.toggleAll = new EventEmitter();
    this.loadingState = new EventEmitter();
   }

  ngOnChanges(changes: SimpleChanges) {
    /**
     * Scale column sizes to 100%:
     */
    if (changes.columns) {
      let _width = 5;
      this.columns.forEach(column => _width += Number(column.width.split('%')[0]));

      this.columns = this.columns.map(column => {
        column.width = Number(column.width.split('%')[0]) / _width * 100 + '%';
        return column;
      });
    }
  }

  stickyHeader(): void {
    setTimeout(e => {
      $( document ).trigger( "stickyTable" );
      $(window).trigger('resizeStickyTable');
    }, 500);
  }

  onColumnClick(event, col, label) {
    this.columnClick.emit({sortColumnName: this.sortColumnName(col), ctrlKey: event.ctrlKey || event.metaKey});
    this.googleAnalyticsService.emitEvent((this.pageName + ' Sort'), 'Click', label);
  }

  sortColumnName(col) {
    return (typeof col === 'object') ? col[Object.keys(col)[0]] : col;
  }

  onToggleAll() {
    if (this.searchResults && this.searchResults.results.length > 0) {
      this.toggleAll.emit();
    }
    this.googleAnalyticsService.emitEvent((this.pageName + ' expand collapse'), 'Link Click', 'Expand collapse all');
  }

  onLoadingState(loadingState: boolean) {
    this.loadingState.emit(loadingState);
  }

  onDownload(event, url) {
    event.preventDefault();
    if (!this.downloading) {
      this.downloadFile(url);
    }
  }

  getAriaSortDescription(sortColumnName, col, sortMap) {
    var sortDescrption = sortMap[sortColumnName(col.name)] != undefined ? sortMap[sortColumnName(col.name)].order : 'desc';
    sortDescrption = 'desc' ? 'Descending' : 'Ascending';
    return sortDescrption;
  }

  getDetailAttributes(options: any, proceedingTypeCategory: string): any[] {
    try {
      return Object.keys(options.details.attributes).map((attribute: string) =>
        options.details.attributes[attribute]).filter((attribute: any) => (
          attribute.proceedingTypes === proceedingTypeCategory ||
          attribute.proceedingTypes === '*'
        ));
    } catch (error) {
      console.error('results-grid.get-detail.attributes', error.message);
      return [];
    }
  }

  getCrossTabAttributes(attributes: any[], proceedingTypeCategory: string) {
    try {
      return attributes.filter(attrib => {
        return !(attrib.respondent[proceedingTypeCategory] == null &&
          attrib.petitioner[proceedingTypeCategory] == null);
      }).map((attrib, index) => {
        return {... attrib, id: index};
      });
    } catch (error) {
      console.error('results-grid.get-crosstab-attributes', error.message);
      return [];
    }
  }

  getParties(row: any): any[] {
    try {
      return Array.isArray(row.additionalRespondentPartyData)
        ? row.additionalRespondentPartyData
        : [];
    } catch (error) {
      return [];
    }
  }

  getAttribute(row: any, attrib: any, party: string) {
    try {
      const prop = attrib[party][row.proceedingTypeCategory];
      if (prop === null) {
        return '-';
      } else {
        return (row.hasOwnProperty(prop) && row[prop].length > 0) ? row[prop] : '-';
      }
    } catch (error) {
      return '@err';
    }
  }

  trackByIndex(index, item) {
    return item ? item.id : null;
  }

  navigateToDocuments(event, proceedingNumber: string) {
    event.preventDefault();
    this.navigateToDocumentsByProceeding(proceedingNumber);
  }

  navigateToDocumentsByProceeding(proceedingNumber: string) {
    this.router.navigate(['search/documents'], {queryParams: {proceedingNumber: proceedingNumber}});
  }

  openInTtabVue(documentId: string, proceedingNumber: string) {
    const regex = /^\/legal-proceeding\/(\d+)\/decision\/(\w+)_(\d+)\.pdf$/
    var matches = regex.exec(documentId)
    var ttabUrl = environment.ttabvueUrl.replace('{0}', proceedingNumber)
    if (matches) {
      ttabUrl = ttabUrl.replace('{1}', matches[2]).replace('{2}', matches[3])
      window.open(ttabUrl, "_blank");
    } else {
      //this.navigateToDocumentsByProceeding(proceedingNumber);
      ttabUrl = ttabUrl.substr(0, ttabUrl.indexOf('&'))
      window.open(ttabUrl, "_blank");
    }
    return false;
  }

  downloadFile(url) {
    this.downloading = true;
    this.onLoadingState(true);
    this.downloadService.download(url).subscribe(result => {
      this.downloading = false;
      this.downloadError = !result;
      this.onLoadingState(false);
    });
  }

  getDocumentUrl(url: string, documentId: string, proceedingId: string, issueDateText: string) {
    // If documentId is present then download the document
    if(documentId) {
      //this.downloadFile(url.replace('{param}', documentId));
      window.open(url.replace('{param}', documentId), "_blank");
    } else {
      // Load the document for a given proceedingNumber and issueDateText
      // Service will load the document and return the documentId
      // Use the documentId to download the document
      var documentLoadUrl = "/decision-document/{procedingId}?issueDate={issueDateText}"
            .replace("{procedingId}", proceedingId)
            .replace("{issueDateText}", issueDateText);
      this.dataService.loadDocument(documentLoadUrl).subscribe(data => {
        if(data) {
          //this.downloadFile(url.replace('{param}', data.documentIdentifier));
          window.open(url.replace('{param}', data.documentIdentifier), "_blank");
        } else {
          this.openErrorDialog();
        }
      },
      err => {
        this.openErrorDialog();
      });
    }
    return false;
  }

  transform(data:string, col:any) {
    if(data && col.transform) {
      for(let t of col.transform) {
        if(data.toLowerCase() == t.key) {
          return t.value;
        }
      }
    }
    return data;
  }

  openErrorDialog() {
    this.downloadError = true;
  }

  closeErrorDialog() {
    this.downloadError = false;
  }

  useTtabVue() {
    return environment.hasOwnProperty('useTtabVue') && environment.useTtabVue == 'true';
  }

}
